export default "__VITE_ASSET__8d065f72__"